import { Overlay } from 'ol'

export function createFeaturePopup(map, options = {}) {
  const { layers = [] } = options

  const container = document.createElement('div')
  container.className = 'overlay-container'
  document.body.appendChild(container)

  const overlay = new Overlay({
    element: container,
  })

  map.addOverlay(overlay)

  function clear() {
    overlay.setPosition(undefined)
    while (container.firstChild) {
      container.firstChild.remove()
    }
  }

  function renderFeature(feature, properties) {
    properties.forEach((prop) => {
      const span = document.createElement('span')
      span.innerHTML = feature.get(prop)

      container.appendChild(span)
      container.appendChild(document.createElement('br'))
    })
  }

  function handleClick(e) {
    clear()

    map.forEachFeatureAtPixel(
      e.pixel,
      (feature, layer) => {
        const config = layers.find(
          l => l.title === layer.get('title'),
        )

        if (!config) return

        renderFeature(feature, config.fields)
        overlay.setPosition(e.coordinate)
      },
    )
  }

  map.on('click', handleClick)

  return {
    overlay,
    clear,
  }
}
